import _ from 'lodash';
import React from 'react';

import {
  Box,
  ButtonBase,
  Stack,
  styled,
  Typography
} from '@mui/material';
import {
  imageUtil,
  ResponsiveImage
} from 'modules/layer0';



const imgsEllipse = imageUtil.getUrlSet('ellipse','png');
const imgsStartupFounder = imageUtil.getUrlSet('startup','png');
const imgsInvestor = imageUtil.getUrlSet('investor','png');



const StyledButtonBase = styled(ButtonBase)<{isSelected: boolean}>(({ theme, isSelected }) => ({
  border: isSelected ? `3px solid ${theme.palette.primary.main}` : undefined,

  width: 310,
  height: 294,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-around',
  borderRadius: _.isNumber(theme.shape.borderRadius) ? theme.shape.borderRadius * 2 : _.parseInt(theme.shape.borderRadius) * 2
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: '20px'
}));

const RelativeBox = styled(Box)(() => ({
  position: 'relative'
}));

const AbsoluteBox = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}));



export interface IProps {
  variant: 'startupFounder' | 'investor'
  isSelected: boolean;
  onClick: () => void;
}

export const FC: React.FC<IProps> = props => {
  return (
    <StyledButtonBase
      onClick={props.onClick}
      isSelected={props.isSelected}>
      <Stack
        spacing={2}
        alignItems="center">
        <RelativeBox>
          <ResponsiveImage.FC
            urlSet={imgsEllipse}
            maxWidth="182px"
            maxHeight="182px" />

          <AbsoluteBox>
            <ResponsiveImage.FC
              urlSet={props.variant === 'startupFounder' ? imgsStartupFounder : imgsInvestor}
              maxWidth="182px"
              maxHeight="182px" />
          </AbsoluteBox>
        </RelativeBox>

        <StyledTypography variant="body1">
          {props.variant === 'startupFounder' ? 'Start-up / Founder' : 'Investor'}
        </StyledTypography>
      </Stack>
    </StyledButtonBase>
  );
};
